
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sapb1reports",
      function () {
        return require("private-next-pages/sapb1reports.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sapb1reports"])
      });
    }
  